<template>
  <div id="explain-container">
  <b>{{ title }}</b>
  <hr/>
  <div v-html="message"></div>
</div>
</template>

<script setup>

  import { computed } from "@vue/reactivity"
  import { ref , watch } from 'vue'

  const props = defineProps({
    title : {
      type : String,
      default : "title"
    },
    message : {
      type : String,
      default : "message"
    },
    scroll : {
      type : Number,
      default : 0
    }
  })

  var scrollTop = 0

  const title = computed({
    get() {
      return props.title
    }
  })

  const message = computed({
    get() {
      return props.message.replace(/\n/g,"<br>")
    }
  })

  const scroll = computed({
    get() {
      return props.scroll
    }
  })

  watch(scroll, (newVal,oldVal) => {
    //console.log('*********** SCROLL',newVal,oldVal)
    var divHeight = document.getElementById('explain-container').offsetHeight;
    //console.log("**** DIV height in scroll watch",divHeight)
    const scrollAmount = (newVal < 0) ? -divHeight : divHeight
    scrollTop += scrollAmount
    if (scrollTop < 0)
      scrollTop = 0
    document.getElementById('explain-container').scroll(0,scrollTop)
  })

</script>

<style scoped>

#explain-container {
  position : relative;
  border-style : solid;
  border-width: 2px;
  margin : 30px auto;
  padding : 15px 15px;
  line-height: 1.4em;
  text-align : left;
  width : calc(100vw - 100px);;
  height: calc(100vh - 125px);
  overflow-y: auto;
}

</style>